import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBaseCountry } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private apiUrl = `${environment.apiUrl}/countries`;

  constructor(private http: HttpClient) {}

  comboCountry(): Observable<IComboBaseCountry[]> {
    return this.http.get<IComboBaseCountry[]>(this.apiUrl+"/combo");
  }
}
